import { memo } from "react";

/**
 * Single source of truth for the site-wide background grid. Fixed,
 * full-viewport, behind all content, radial-masked so lines fade toward
 * the edges. Tune via --grid-size / --grid-opacity in index.css.
 */
export const BackgroundGrid = memo(() => (
  <div className="fixed inset-0 -z-30 bg-grid-global pointer-events-none" aria-hidden="true" />
));

BackgroundGrid.displayName = "BackgroundGrid";

export default BackgroundGrid;
